// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"CardContent_cardContent__1-2On"};